<template>
  <vue-funnel-graph
    :width="width"
    :height="height"
    :labels="labels"
    :values="values"
    :colors="colors"
    :sub-labels="subLabels"
    :direction="direction"
    :gradient-direction="gradientDirection"
    :animated="true"
    :display-percentage="display_percentage"
  ></vue-funnel-graph>
</template>

<script>
import { VueFunnelGraph } from "vue-funnel-graph-js"; // https://github.com/greghub/vue-funnel-graph-js

export default {
  name: "funnel",
  components: {
    VueFunnelGraph
  },
  props: ["data"],
  data() {
    return {
      labels: [],
      subLabels: [],
      values: [],
      colors: [],
      direction: "",
      gradientDirection: "",
      height: 0,
      width: 0,
      display_percentage: false
    };
  },
  beforeMount() {
    this.labels = this.data.labels;
    this.subLabels = this.data.subLabels;
    this.values = this.data.values;
    this.colors = this.data.colors;
    this.direction = this.data.direction;
    this.gradientDirection = this.data.gradientDirection;
    this.height = this.data.height;
    this.width = this.data.width;
    this.display_percentage = this.data.display_percentage;
  }
};
</script> 